const ACL_NOP = 0x00000000
const ACL_OBJ_DEL = ACL_NOP + 1
const ACL_OBJ_READ = ACL_OBJ_DEL << 1
const ACL_OBJ_LIST = ACL_OBJ_READ
const ACL_OBJ_CREATE = ACL_OBJ_DEL << 2
const ACL_OBJ_UPDATE = ACL_OBJ_DEL << 3
const ACL_OBJ_WRITE = ACL_OBJ_UPDATE
const ACL_USR_CREATE = ACL_OBJ_DEL << 4
const ACL_USR_DELETE = ACL_USR_CREATE
const ACL_USR_REMOTE_LOG = ACL_OBJ_DEL << 5
const ACL_USR_LIST = ACL_OBJ_DEL << 6
const ACL_SYS_OPERATOR = ACL_OBJ_DEL << 7
const ACL_SYS_BACKUP = ACL_OBJ_DEL << 8
const ACL_SYS_RESTORE = ACL_SYS_BACKUP
const ACL_SYS_UDATE_HSM = ACL_OBJ_DEL << 9
const ACL_NS_AUTHORIZATION = ACL_OBJ_DEL << 10
const ACL_VIRTUAL_OTP_AUTH = ACL_OBJ_DEL << 29
const ACL_VIRTUAL_X509_AUTH = ACL_OBJ_DEL << 28
const ACL_CHANGE_PWD_NEXT_TIME = ACL_OBJ_DEL << 30

export const state = {
  ACL_NOP,
  ACL_OBJ_DEL,
  ACL_OBJ_READ,
  ACL_OBJ_LIST,
  ACL_OBJ_CREATE,
  ACL_OBJ_UPDATE,
  ACL_OBJ_WRITE,
  ACL_USR_CREATE,
  ACL_USR_DELETE,
  ACL_USR_REMOTE_LOG,
  ACL_USR_LIST,
  ACL_SYS_OPERATOR,
  ACL_SYS_BACKUP,
  ACL_SYS_RESTORE,
  ACL_SYS_UDATE_HSM,
  ACL_NS_AUTHORIZATION,
  ACL_VIRTUAL_OTP_AUTH,
  ACL_VIRTUAL_X509_AUTH,
  ACL_CHANGE_PWD_NEXT_TIME
}

export const getters = {
  getAcl: state => ({
    canDeleteObjects,
    canReadObjects,
    canCreateObjects,
    canUpdateObjects,
    isOperator,
    isMxN,
    isTfa,
    isChangePass,
    canCreateRemoveUsers,
    canListUsers,
    canMonitorRemoteLog,
    canBackupRestore,
    canFirmwareUpdate
  }) => {
    let acl = state.ACL_NOP

    canDeleteObjects && (acl |= state.ACL_OBJ_DEL)
    canReadObjects && (acl |= state.ACL_OBJ_READ)
    canCreateObjects && (acl |= state.ACL_OBJ_CREATE)
    canUpdateObjects && (acl |= state.ACL_OBJ_UPDATE)

    isOperator && (acl |= state.ACL_SYS_OPERATOR)
    isMxN && (acl |= state.ACL_NS_AUTHORIZATION)
    isTfa && (acl |= state.ACL_VIRTUAL_OTP_AUTH)
    isChangePass && (acl |= state.ACL_CHANGE_PWD_NEXT_TIME)
    canCreateRemoveUsers && (acl |= state.ACL_USR_CREATE)
    canCreateRemoveUsers && (acl |= state.ACL_USR_DELETE)
    canListUsers && (acl |= state.ACL_USR_LIST)
    canMonitorRemoteLog && (acl |= state.ACL_USR_REMOTE_LOG)
    canBackupRestore && (acl |= state.ACL_SYS_BACKUP)
    canBackupRestore && (acl |= state.ACL_SYS_RESTORE)
    canFirmwareUpdate && (acl |= state.ACL_SYS_UDATE_HSM)

    return acl
  },
  getPermissions: state => ({ acl }) => {
    const isOperator = !!(acl & state.ACL_SYS_OPERATOR)
    const canDeleteObjects = isOperator || !!(acl & state.ACL_OBJ_DEL)
    const canReadObjects = isOperator || !!(acl & state.ACL_OBJ_READ)
    const canListObjects = isOperator || !!(acl & state.ACL_OBJ_LIST)
    const canCreateObjects = isOperator || !!(acl & state.ACL_OBJ_CREATE)
    const canUpdateObjects = isOperator || !!(acl & state.ACL_OBJ_UPDATE)
    const canWriteObjects = isOperator || !!(acl & state.ACL_OBJ_WRITE)
    const canCreateUser = isOperator || !!(acl & state.ACL_USR_CREATE)
    const canDeleteUser = isOperator || !!(acl & state.ACL_USR_DELETE)
    const canCreateAndDeleteUser = canCreateUser && canDeleteUser
    const canUserAccessRemoteLog =
      isOperator || !!(acl & state.ACL_USR_REMOTE_LOG)
    const canListUser = isOperator || !!(acl & state.ACL_USR_LIST)
    const canUserExtractBackup = isOperator || !!(acl & state.ACL_SYS_BACKUP)
    const canUserRestoreBackup = isOperator || !!(acl & state.ACL_SYS_RESTORE)
    const canUserUpdateFirmware =
      isOperator || !!(acl & state.ACL_SYS_UDATE_HSM)
    const isUserNSAuthorization = !!(acl & state.ACL_NS_AUTHORIZATION)
    const isUserTfaOtp = !!(acl & state.ACL_VIRTUAL_OTP_AUTH)
    const isUserTfaX509 = !!(acl & state.ACL_VIRTUAL_X509_AUTH)
    const isUserToken = isUserTfaOtp || isUserTfaX509
    const isChangePasswordNextLogin = !!(acl & state.ACL_CHANGE_PWD_NEXT_TIME)

    const perm = {
      isOperator,
      canDeleteObjects,
      canReadObjects,
      canListObjects,
      canCreateObjects,
      canUpdateObjects,
      canWriteObjects,
      canCreateUser,
      canDeleteUser,
      canCreateAndDeleteUser,
      canUserAccessRemoteLog,
      canListUser,
      canUserExtractBackup,
      canUserRestoreBackup,
      canUserUpdateFirmware,
      isUserNSAuthorization,
      isUserToken,
      isUserTfaOtp,
      isUserTfaX509,
      isChangePasswordNextLogin
    }

    return perm
  }
}

export const mutations = {}

export const actions = {}
